import { doPost } from "../api/API"
import { loaderModal } from "../AlertLoaderService"
import { isChemistStoreLoaded } from "../CommonUtils"

import { AppVersionCode, ServiceName } from "../../constants/AppConstants"

export const getPaymentOffersAndModes = () => {
    loaderModal.setLoader(true);
    const chemistStoreLoaded = isChemistStoreLoaded()
    const param = { pwa: true, locale: 'en', appVersionCode: AppVersionCode }
    if (chemistStoreLoaded) param['serviceName'] = ServiceName.order
    return new Promise((resolve) => {
        doPost('v2207/payment/list_payment_offers_and_modes', param).then(
            (response: any) => {
                if (response) resolve(response)
                else resolve({ offers: [] })
                loaderModal.setLoader(false);
            }, (err: any) => {
                resolve({ offers: [] })
                loaderModal.setLoader(false);
            })
    })
}